var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".list_svg__cls-1{fill:currentColor}"))), /*#__PURE__*/React.createElement("g", {
    id: "list_svg__Group_21553",
    "data-name": "Group 21553",
    transform: "translate(-944 -771)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list_svg__Group_21552",
    "data-name": "Group 21552",
    transform: "translate(946.667 777.667)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "list_svg__Rectangle_19928",
    "data-name": "Rectangle 19928",
    className: "list_svg__cls-1",
    width: 15.373,
    height: 2.196,
    rx: 1.098,
    transform: "translate(3.294)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "list_svg__Rectangle_19930",
    "data-name": "Rectangle 19930",
    className: "list_svg__cls-1",
    width: 15.373,
    height: 2.196,
    rx: 1.098,
    transform: "translate(3.294 4.392)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "list_svg__Rectangle_19931",
    "data-name": "Rectangle 19931",
    className: "list_svg__cls-1",
    width: 15.373,
    height: 2.196,
    rx: 1.098,
    transform: "translate(3.294 8.784)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "list_svg__Rectangle_19932",
    "data-name": "Rectangle 19932",
    className: "list_svg__cls-1",
    width: 2.196,
    height: 2.196,
    rx: 1.098,
    transform: "translate(0 8.784)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "list_svg__Rectangle_19933",
    "data-name": "Rectangle 19933",
    className: "list_svg__cls-1",
    width: 2.196,
    height: 2.196,
    rx: 1.098,
    transform: "translate(0 4.392)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "list_svg__Rectangle_19934",
    "data-name": "Rectangle 19934",
    className: "list_svg__cls-1",
    width: 2.196,
    height: 2.196,
    rx: 1.098
  }))), /*#__PURE__*/React.createElement("path", {
    id: "list_svg__Rectangle_19851",
    "data-name": "Rectangle 19851",
    transform: "translate(944 771)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  })));
};

export default SvgList;